import lang from "element-ui/lib/locale/lang/zh-CN"; // 引入element语言包
const messages = {
  极兔开放平台: "极兔开放平台",
  帮助中心: "帮助中心",
  '注 册': "注 册",
  indexPage: {
    title: "快递服务技术对接平台",
    BannerTxt: "共享极兔各类服务接口，实现物流供应链一体化，帮助企业高效完成快递寄件、信息跟踪，提供快件信息安全的增值服务。实现与极兔的高效合作。",
    BannerBtnTxt: "加入极兔开放平台",
  },
  helpCenter: {
    常用工具: "常用工具",
    签名工具: "签名工具",
    电子面单模板: "电子面单模板",
    "API-SDK说明": "API-SDK说明",
    签名方式:"签名方式",
    method_1:"1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;",
    method_2:"2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再base64加密;",
    method_3:"3. 例如：base64(MD5({“age”:18,”gender”:”male”,”name”:”张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。",
    method_4:"4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。",
    method_5:"5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；",
    method_6:"6. 部分接口示例代码和sdk请参考示例代码、SDK文档。",
    业务参数签名:"业务参数签名",
    请输入加密后的32位pwd:"请输入加密后的32位pwd",
    获取:"获取",
    Headers签名:"Headers签名",
    bussness:`示例：在调用下单、取消订单等接口时，需要业务参数<code>digest</code>，而业务参数<code>digest</code>跟全局Headers里面的<code>digest</code>含义不一样。`,
    bussness_1:`首先，极兔会分配一个协议客户下单所需的账号和密码。例如：<code>J0086474299</code>/<code>H5CD3zE6</code>,其中<code>pwd</code>等于<code>MD5(明文密码(H5CD3zE6)+jadada236t2)</code>
    后大写,比如此示例生成的32位<code>pwd</code>为<code>6A272C3DD1F3CD2F92BF567C37040910</code>,最后按照规则Base64(Md5(客户编号+密文+privateKey))生成业务参数签名。`,
    bussness_2:`即：业务参数签名<code>digest</code>=Base64(Md5(<code>J0086474299</code>+<code>6A272C3DD1F3CD2F92BF567C37040910</code>+privateKey))`,
    headers_1:`示例：以取消订单为例：假设业务参数为  bizContent为<code>{"customerCode": "J0086474299","digest": "U40e5sumorgd3YgZzU","txlogisticId": "10000000001299","reason": "YL1234567890123"}</code>,那么此时的header里面的签名digest等于<code>base64(md5(业务参数的Json+privateKey))</code>,`,
    headers_2:`即 <code>base64(md5({"customerCode": "J0086474299","digest": " U40e5sumorgd3YgZzU", "txlogisticId":"10000000001299","reason": "YL1234567890123"}+privateKey))</code>。`,
    headers_3:`注：<code>privateKey</code>为账号通过平台认证后自动分配`,
    一联模版:"一联模版",
    "API开放平台-SDK":"API开放平台-SDK",
    "Introduction":"一、简介",
    "sdk_two":"二、版本更新记录",
    "sdk_3_title":"三、快速入门 安装API开放平台 SDK",
    "sdk_4_title":"四、API-SDK目录结构",
    "sdk_5_title":"五、直接使用JAR包步骤如下：",
    "sdk_6_title":"六、SDK相关maven依赖",
    "sdk_7_title":"七、创建JtExpressApi",
    "sdk_8_title":"八、建议",
    "Introduction_1":"Hi，您好，欢迎使用API开放平台。",
    "Introduction_2":"本文档主要针对平台开发者，描述快递服务技术对接平台的相关技术内容。如果您对文档内容有任何疑问，可以联系平台运营解答疑问。",
    date:"日期",
    sdkVersion:"版本号",
    updata:"更新内容",
    updataInfo:"提供了调用开放平台接口的通用标准，辅助完成接口的签名",
    "语言":"语言",
    最新版本:"最新版本",
    项目示例:"项目示例",
    开发环境:"开发环境",
    "支持JAVA版本":"支持 JAVA版本：1.8+",
    "支持PHP":"支持 PHP7.0及以上",
    签名相关类:"签名相关类",
    公用类:"公用类",
    异常相关类:"异常相关类",
    Http通信相关类:"Http通信相关类",
    开放平台api通用接口:"开放平台api通用接口",
    执行器接口:"执行器接口",
    sdk_5_txt:`<p>1.SDK压缩工具包由开放平台提供。</p>
    <p>2.将开放平台提供的"jt-openapi-sdk.zip"解压后，复制到工程文件夹中。</p>
    <p>3.点击 File -> Project Structure（快捷键 Ctrl + Alt + Shift + s），点击Project Structure界面左侧的“Modules。</p>
    <p>4.在 “Dependencies” 标签界面下，点击右边的 “+”号，选择第一个选项“JARs or directories...”，选择相应的jar包，点“OK”，jar包添加成功。</p>
    <p>5.具体接口的SDK调用方法可以下载‘示例实用项目.zip’进行参考。</p>`,
    sdk_6_txt:"SDK默认使用slf4j-api包进行日志输出;SDK默认使用fastjson进行json数据转换；SDK默认使用httpclient进行http数据传输。",
    sdk_7_txt:`<p>JtExpressApi是极兔开放平台api通用执行器,为使用极兔开放平台的开发人员提供了一系列的交互方法。</p>
    <p>用户可以参考如下代码新建一个JtExpressApi,初始化完成后建议单例使用,避免重复创建:</p>`,
    sdk_8_txt:`<p>如果你是用springboot框架来调用API开放平台-SDK相关接口,建议把JtExpressApi放到spring容器中进行管理,</p>
    <p>用户可以参考如下代码新建一个配置类:</p>`,
  },
  controlPage:{
    "审核状态": "审核状态",
    请输入酋长国: "请输入酋长国",
    请输入区域: "请输入区域",
    公司详细地址: "公司详细地址",
    请输入社会信用代码: "请输入社会信用代码",
    请上传营业执照: "请上传营业执照",
    请输入法人身份证: "请输入法人身份证",
    身份证详细地址: "身份证详细地址",
    "请输入8位邮编匹配地址，境外地址请输入99999999": "请输入8位邮编匹配地址，境外地址请输入99999999",
    境外地址: "境外地址"
  },
  message: {},
  apiDoc: {
    极兔API简介: "极兔API简介",
    订单服务: "订单服务",
    本地订单: "本地订单",
    创建订单: "创建订单",
    查询订单: "查询订单",
    取消订单: "取消订单",
    订单状态回传: "订单状态回传",
    运费时效查询: "运费时效查询",
    散客寄件: "散客寄件",
    物流轨迹: "物流轨迹",
    物流轨迹查询: "物流轨迹查询",
    物流轨迹订阅: "物流轨迹订阅",
    物流轨迹回传: "物流轨迹回传",
    API简介: "API简介",
    IntroductionContent: "为了更好的服务广大客户，极兔开放平台提供标准统一的接入API，为客户与平台直接实现数据的交互，提高双方的便利。本平台将接入的流程和步骤进行详细的描述，方便客户更快速准确的接入API平台。",
    "对接流程": "对接流程",
    process_1: "1.注册用户，注册成为极兔开放平台的一员",
    process_2: "2.申请成为开发者，完善开发者信息，成为极兔开放平台普通开发者。",
    process_3: "3.企业认证，完善企业信息，获取全部接口权限，可使用订单服务、电子面单服务等。",
    process_4: "4.联调测试，调试测试环境接口服务，与具体的接口服务人员沟通解决问题。",
    process_5: "5.发布上线，联调测试通过后，联系具体的接口服务人员，确认上线细节。",
    签名方式:"签名方式",
    method_1:"1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;",
    method_2:"2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再base64加密;",
    method_3:"3. 例如：base64(MD5({“age”:18,”gender”:”male”,”name”:”张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。",
    method_4:"4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。",
    method_5:"5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；",
    method_6:"6. 部分接口示例代码和sdk请参考示例代码、SDK文档。",
    在线文档: "在线文档",
    测试工具: "测试工具",
    失败: "失败",
    Headers签名失败: "Headers签名失败",
    内部调用异常: "内部调用异常",
    apiAccount为空: "apiAccount为空",
    digest为空: "digest为空",
    timestamp为空: "timestamp为空",
    系统错误: "系统错误",
    非法参数: "非法参数",
    '其他服务': '其他服务',
    '重量推送': '重量推送',
    '重量订阅': '重量订阅',
    'Dce申报': 'Dce申报',
    '获取电子面单': '获取电子面单',
    '跨境订单': '跨境订单',
    '清关下单': '清关下单',
    '更新清关订单': '更新清关订单',
    '清关下发航班信息': '清关下发航班信息',
    '清关订单详情': '清关订单详情',
    '取消清关单': '取消清关单',
    '打印清关单': '打印清关单',
    '清关打印大包': '清关打印大包',
    '更新DIR': '更新DIR',
  },
  onlineDoc: {
    comCostAndTime: "未下单前查询预计运费和时效",
    digestnew: "1.MD5签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写2.SHA256签名，Sha256(客户编号+密文+privateKey)，其中密文：Sha256(明文密码)",
    "目的地邮编": "目的地邮编",
    "始发地邮编": "始发地邮编",
    "产品类型编码": "产品类型：仅支持“standard（快运）、express（快递）、EZ（普通快递）、CRD（普通快递）",
    "重量（正数），单位kg，范围0.01-30，为空默认0.02": "重量（正数），单位kg，范围0.01-30，为空默认0.02",
    "物品价值": "物品价值",
    "物品类型编码": "物品类型（对应订单主表物品类型）:<p>bm000001 文件</p><p>bm000002 数码产品</p><p>bm000003 生活用品</p><p>bm000004 食品</p><p>bm000005 服饰</p><p>bm000006 其他</p><p>bm000007 生鲜类</p><p>bm000008 易碎品</p><p>bm000009 液体</p>",
    "服务方式编码": "服务方式：<p>02 门店寄件 ； </p><p>01 上门取件</p>",
    "结算方式(1:寄件现结,2寄付月结,3:到付现结)": "结算方式(1:寄件现结,2寄付月结,3:到付现结)",
    "报价类型, 0: 普通报价， 1：同城报价，2：同省报价": "报价类型, 0: 普通报价， 1：同城报价，2：同省报价",
    "运费": "运费",
    "保险费+风险费": "保险费+风险费",
    "保险费+风险费+运单运费": "保险费+风险费+运单运费",
    "时效/天": "时效/天",
    地址: "地址：使用接入方提供的URL",
    请求方法: "请求方法：",
    数据类型: "数据类型：",
    响应类型: "响应类型：",
    接口说明: "接口说明",
    接口信息: "接口信息",
    参数描述: "参数描述",
    Headers: "Headers",
    请求参数: "请求参数",
    业务参数: "业务参数",
    sender类型说明: "sender类型说明",
    receiver类型说明: "receiver类型说明",
    items类型说明: "items类型说明",
    customsInfo类型说明: "customsInfo类型说明",
    details类型说明: "Type description",
    报文描述: "报文描述",
    响应参数: "响应参数",
    data类型说明: "data类型说明",
    请求示例: "请求示例",
    返回示例: "返回示例",
    错误代码: "错误代码",
    错误编码: "错误编码",
    错误描述: "错误描述",
    测试地址: "测试地址：",
    正式地址: "正式地址：",
    测试apiAccount: "测试apiAccount：",
    测试privateKey: "测试privateKey：",
    属性名: "属性名",
    属性类型: "属性类型",
    是否必填: "是否必填",
    示例: "示例",
    描述: '描述',
    OrderDescription_1: "与平台签约的客户，可通过此接口创建/修改订单。目前创建订单接口支持修改订单，即如果客户订单号（txlogisticId）已存在，且对应的订单未揽件，则直接修改已有订单。如果收件地址发生变更就重新获取最新的三段码/大头笔返回；",
    OrderDescription_2: "查询新增订单接口创建的订单",
    OrderDescription_3: "取消通过新增订单接口生成的订单",
    OrderDescription_4: "接入方在提供了物流状态回传相关信息并完成了下订单操作后，当订单相关的状态变化时，系统会根据接入方配置的推送账户主动推送物流信息。",
    OrderDescription_5: "非网点签约客户可通过此接口创建散客订单。目前散客寄件接口支持修改订单，即如果客户订单号（txlogisticId）已存在，且对应的订单未揽件，则直接修改已有订单。可通过“实名制信息上传”接口上传寄件用户信息；",
    "通过单号查询快件的轨迹信息": "通过单号查询快件的轨迹信息",
    trackDescription_1: "通过单号查询快件的轨迹信息",
    trackDescription_2: `向极兔订阅需推送物流轨迹的运单号 <br/> <strong>注意事项：需提供回传物流轨迹的URL</strong> `,
    trackDescription_3: "接入方在提供了快递轨迹推送相关信息并完成了下订单操作后，当订单相关的运单轨迹变化时，系统会根据接入方配置的推送账户主动推送物流信息。",
    // 表单描述翻译
    接入方在平台的api账户标识: "接入方在平台的api账户标识",
    签名字符串: "签名字符串",
    "时间戳，毫秒": "时间戳，毫秒",
    业务参数模块内json格式的string类型: "业务参数模块内json格式的string类型",
    "客户编码（联系出货网点提供）": "客户编码（联系出货网点提供）",
    sign: "签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写",
    合作网点: "合作网点",
    "客户订单号（传客户自己系统的订单号）": "客户订单号（传客户自己系统的订单号）",
    ExpressType: "快件类型：仅支持“standard（快运）、express（快递）",
    ExpressType1: "快件类型：仅支持“standard（快运）、express（快递）、EZ（普通快递）、CRD（普通快递）",
    OrderType: "订单类型（有客户编号为月结）1、 散客；2、月结；",
    "服务类型": "服务类型 ：02 门店寄件 ； 01 上门取件；10 Drop_Off",
    "服务类型create": "服务类型 ：02 门店寄件 ； 01 上门取件（门店寄件时，取件地址字段为必传）；10 Drop_Off",
    "派送类型": "派送类型：03 派送上门",
    paymentMethod: "支付方式：PP_PM(“寄付月结”), CC_CASH(“到付现结”);",
    寄件信息对象: "寄件信息对象",
    收件信息对象: "收件信息对象",
    取件信息对象: "取件信息对象",
    LC_pick_up_start_time: "物流公司上门取货开始时间 yyyy-MM-dd HH:mm:ss",
    CLC_door_to_door_end_time: "客户物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss",
    itemtType: "物品类型（对应订单主表物品类型）:<p>bm000001 文件</p>  <p>bm000002 数码产品</p>  <p>bm000003 生活用品</p>  <p>bm000004  食品</p>  <p>bm000005  服饰</p>  <p>bm000006  其他</p>  <p>bm000007 生鲜类</p>  <p>bm000008 易碎品</p><p>bm000009 液体</p>",
    Length: "长，cm",
    Width: "宽，cm",
    Height: "高，cm",
    volume: "体积",
    Weight: "重量，单位kg，范围0.01-30",
    "包裹总件数": "包裹总件数",
    "包裹总票数(必须为1)": "包裹总票数(必须为1)",
    "包裹总票数": "包裹总票数",
    "代收货款金额 (数值型)": "代收货款金额 (数值型)",
    collectionPayment: "代收货款币别（默认本国币别，如：BRL）",
    offerFee: "保价金额(数值型)，单位：BRL",
    "备注": "备注",
    "商品信息列表": "商品信息列表",
    "子订单信息": "子订单信息",
    "客户信息": "客户信息",
    "寄件人姓名": "寄件人姓名",
    "寄件公司": "寄件公司",
    "寄件邮编": "寄件邮编",
    "寄件邮编（固定8位长度）": "寄件邮编（固定8位长度）",
    "寄件邮箱": "寄件邮箱",
    "taxNumber": "个人税号",
    "taxNumberNew": "个人税号（无子单时为必填，有子单时子单的个人税号为必填，主单为非必填，限制14位字符）",
    "寄件地区": "寄件地区",
    "invoceNumber": "输入发票号码",
    "invoceNumberNew": "发票号码（若无子订单信息则为必填）",
    "invoiceSerialNumber": "发票序列号（若无子订单信息则为必填）",
    "invoicemoney": "发票金额(数值型)，单位：BRL（若无子订单信息则为必填）",
    "taxCode": "发票税号（若无子订单信息则为必填）",
    "invoiceAccessKey": "发票密钥（若无子订单信息则为必填）",
    "invoiceIssueDate": "发票开具日期",
    "packingNumber": "输入包装清单编号",
    "documentNumber": "文件编号",
    "documentSeries": "文件系列",
    "documentKey": "文件密钥",
    "documentCteKey": "税务文件密钥",
    "cteKey": "CTe秘钥或NFSe秘钥",
    "invoiceType": "类型字段(NFe CTe NFSe)",
    "docType": "0:NFE、20：DCe，不传默认NFE,传DCe则校验识别号相关信息：<br/>0:NFE：<br/>（invoiceNumber、invoiceSerialNumber、invoiceMoney、invoiceAccessKey、taxCode必传）<br/>20.DCe：<br/>（invoiceAccessKey、invoiceMoney、invoiceIssueDate必传）",
    "orderInformation类型说明(数组)": "orderInformation类型说明(数组)",
    "发票号码": "发票号码",
    "发票序列号": "发票序列号",
    "发票金额(数值型)，单位：BRL": "发票金额(数值型)，单位：BRL",
    "发票税号": "发票税号",
    "发票密钥": "发票密钥",
    "寄件州": "寄件州",
    "寄件市": "寄件市",
    "寄件区": "寄件区",
    "寄件街道号": "寄件街道号",
    "寄件详细地址": "寄件详细地址",
    "寄件人IE号": "寄件人IE号",
    "taxNumber2": "个人税号（无子单时为必填，有子单时子单的个人税号为必填，主单为非必填）",
    "收件州": "收件州",
    "收件市": "收件市",
    "收件区": "收件区",
    "收件街道号": "收件街道号",
    "收件详细地址": "收件详细地址",
    "收件人IE号": "收件人IE号",
    "translate类型说明": "translate类型说明",
    "取件人姓名": "取件人姓名",
    "取件公司": "取件公司",
    "取件邮编": "取件邮编（固定8位长度）",
    "取件邮箱": "取件邮箱",
    "个人税号（限制14位字符）": "个人税号（限制14位字符）",
    "取件人手机（手机和电话二选一必填）": "取件人手机（手机和电话二选一必填）",
    "取件人电话（手机和电话二选一必填）": "取件人电话（手机和电话二选一必填）",
    "取件州": "取件州",
    "取件市": "取件市",
    "取件区": "取件区",
    "取件街道": "取件街道",
    "取件街道号": "取件街道号",
    "取件详细地址": "取件详细地址",
    "取件区号": "取件区号",
    "取件人IE号": "取件人IE号",
    "商品NCM": "商品NCM",
    "NCM描述": "NCM描述",
    "返回订单信息": "返回订单信息",
    "orderList类型说明（数组）": "orderList类型说明（数组）",
    SendingMobilePhone: "寄件手机（手机和电话二选一必填）",
    SendingPhoneNumber: "寄件电话（手机和电话二选一必填）",
    ThreeCharacterSending: "寄件国家三字码（如：阿联酋=UAE、中国=CHN、印尼=IDN）",
    "寄件酋长国": "寄件酋长国",
    "寄件区域": "寄件区域",
    "寄件街道": "寄件街道",
    ShippingDetailedAddress: "寄件详细地址（酋长国+区域+街道+详细地址）",
    "寄件区号": "寄件区号",
    "收件人姓名": "收件人姓名",
    "收件公司": "收件公司",
    "收件邮编": "收件邮编",
    "收件邮编（固定8位长度）": "收件邮编（固定8位长度）",
    "收件邮箱": "收件邮箱",
    ReceivingMobilephone: "收件手机（手机和电话二选一必填）",
    ReceivingPhoneNumber: "收件电话（手机和电话二选一必填）",
    ThreeCharacterRecipient: "收件国家三字码（如：阿联酋=UAE、中国=CHN、印尼=IDN）",
    "收件酋长国": "收件酋长国",
    "收件区域": "收件区域",
    "收件街道": "收件街道",
    ReceivingDetailedAddress: "收件详细地址（酋长国+区域+街道+详细地址）",
    "收件区号": "收件区号",
    物品类型: "物品类型: <p>bm000001 文件</p>  <p>bm000002 数码产品</p>  <p>bm000003 生活用品</p>  <p>bm000004  食品</p>  <p>bm000005  服饰</p>  <p>bm000006  其他</p>  <p>bm000007 生鲜类</p>  <p>bm000008 易碎品</p><p>bm000009 液体</p>",
    "物品名称": "物品名称",
    "物品中文名称": "物品中文名称",
    "物品英文名称": "物品英文名称",
    cases: "件数，≥1",
    "申报价值(数值型)": "申报价值(数值型)",
    priceCurrency: "申报货款币别（默认本国币别，如：BRL）",
    "物品描述": "物品描述",
    "商品URL": "商品URL",
    "货物数量 跨境件报关需要填写": "货物数量 跨境件报关需要填写",
    货物单位: "货物单位，如：个、台、本， 跨境件报关需要填写",
    原产地国别: "原产地国别， 跨境件报关需要填写",
    货物产品国检备案编号: "货物产品国检备案编号 跨境件报关需要填写",
    商品海关备案号: "商品海关备案号 跨境件报关需要填写",
    商品行邮税号: "商品行邮税号 跨境件报关需要填写",
    海关编码: "海关编码 跨境件报关需要填写",
    商品编号: "商品编号 跨境件报关需要填写",
    货物品牌: "货物品牌 跨境件报关需要填写",
    货物规格型号: "货物规格型号 跨境件报关需要填写",
    生产厂家: "生产厂家 跨境件报关需要填写",
    托寄物声明价值: "托寄物声明价值 跨境件报关需要填写",
    托寄物声明价值币别: "托寄物声明价值币别 跨境件报关需要填写",
    客户支付的运费: "客户支付的运费 跨境件报关需要填写",
    "返回码，见附录": "返回码，见附录",
    "业务数据": "业务数据",
    "集包地": "集包地",
    "返回客户订单号": "返回客户订单号",
    "订单创建时间": "订单创建时间 yyyy-MM-dd HH:mm:ss",
    "三段码online": "三段码（获取到三段码优先返回三段码，无三段码返回大头笔）",
    "参考总运费": "参考总运费（数值型）",
    "查询命令": "查询命令 1.按客户订单编号查询   2.按运单编号查询（用运单号查订单状态）   3.按下单时间段查询（查订单）（按时间段查询返回不限制条数）  4.订单编号",
    "查询命令：（枚举）": "查询命令：（枚举）空或者不传：默认使用billCodes查询轨迹；<p>0：billCodes （使用运单号查询）</p><p>1：invoiceAccessKey（使用发票秘钥查询）</p><p>2：customerOrderNumber（使用客户订单编号查询）</p>",
    "运单号多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单": "运单号多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单",
    "发票秘钥多个发票秘钥以英文逗号隔开,目前先支持一次性最多查询30票运单": "发票秘钥多个发票秘钥以英文逗号隔开,目前先支持一次性最多查询30票运单",
    "客户订单编号多个运以英文逗号隔开,目前先支持一次性最多查询30票运单": "客户订单编号多个运以英文逗号隔开,目前先支持一次性最多查询30票运单",
    "发票秘钥": "发票秘钥",
    command: "command=1 客户订单编号查询 ;command=2 运单编号暂时;command=4订单号（公司内部）支持200个; Command=1、2或3时必填",
    startDate: "开始时间(24小时制: yyyy-MM-dd HH:mm:ss)（command为3时必填）（客户下单时间）command = 3 时必填",
    endDate: "结束时间(24小时制: yyyy-MM-dd HH:mm:ss)（command为3时必填），时间范围最大7天command = 3 时必填",
    status: "状态（订单状态取下方状态表，筛选数据使用，默认全部）:已取消 104 ;已取件 103 ;已调派业务员 102 ;已调派网点 101 ;未调派 100",
    "command = 3 时必填": "command = 3 时必填",
    系统订单号: "系统订单号",
    "客户订单号-客户自己系统的订单号": "客户订单号    客户自己系统的订单号",
    订单状态: "订单状态 ：已取消 104 ；已取件 103 ；已调派业务员 102 ；已调派网点 101 ；未调派 100",
    订单类型: "订单类型  ：01散客  02月结",
    三段码: "三段码",
    "客户编码（订单类型传2时，必填）": "客户编码（订单类型传2时，必填）",
    "客户编码必填描述": "<p>客户编码</p>当使用customerOrderNumber请求查询轨迹时，客户编码为必填",
    "订单类型  1（散客），2（协议客户）": "订单类型  1（散客），2（协议客户）",
    "取消原因": "取消原因",
    "运单号": "运单号",
    "客户订单号": "客户订单号",
    operateType: "事件，客户填写“新增”则进行订单新增，；客户传“更新”，则进行订单更新<p>1 新增</p><p>2 修改</p>",
    客户订单编号: "客户订单编号",
    极兔运单编号: "极兔运单编号",
    "网点名称（“已调派业务员”回传）": "网点名称（“已调派业务员”回传）",
    "业务员名称（“已调派业务员”回传）": "业务员名称（“已调派业务员”回传）",
    "业务员联系方式（“已调派业务员”回传）": "业务员联系方式（“已调派业务员”回传）",
    极兔订单编号: "极兔订单编号",
    "重量（“已揽收”“已取件”时回传）": "重量（“已揽收”“已取件”时回传）",
    "订单取消原因（“已取消”时回传）": "订单取消原因（“已取消”时回传）",
    "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)": "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)",
    "时间": "时间",
    承运商编码: "承运商编码",
    "业务员编码（联系出货网点提供，且采用网点编码签名）": "业务员编码（联系出货网点提供，且采用网点编码签名）",
    "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写": "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写",
    运单编号: "运单编号",
    "快件类型：EZ(标准快递)": "快件类型：EZ(标准快递)",
    "订单类型  1、散客；": "订单类型  1、散客；",
    "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）": "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）",
    "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss": "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss",
    "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单": "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单",
    运单轨迹详情: "运单轨迹详情",
    扫描时间: "扫描时间",
    轨迹描述:  "轨迹描述",
    scanType: "扫描类型 <p>1、快件揽收</p> <p>2、入仓扫描（停用）</p> <p>3、发件扫描</p> <p>4、到件扫描</p> <p>5、出仓扫描</p> <p>10、快件签收</p> <p>11、问题件扫描</p> <p>12、退回件扫描</p> <p>13、中心到件</p> <p>16、寄件入库扫描</p>",
    scanCode: "扫描类型编码： <p>快件揽收：10</p> <p>入仓扫描（停用）：20</p> <p>发件扫描：50</p> <p>中心到件：90</p> <p>到件扫描：92</p>  <p>出仓扫描：94</p>  <p>快件签收：100</p> <p>问题件扫描：110</p> <p>退回件扫描：172</p> <p>寄件入库扫描：210</p>",
    problemType: "<p>P71a 包装不规范C</p><p>P13a 地址信息不详C</p><p>P13b 地址信息错误C</p><p>D13a 地址信息不详</p><p>D13b 地址信息错误</p><p>D16a 无理由拒收</p><p>D65a 客户地址无法进入</p><p>D65b 客户不在</p><p>D65n 多次派送客户不在</p><p>D66b 政府/税务查件</p><p>D66c 异常天气</p><p>R17a 退回件</p><p>R73b 退回客户或P仓不成功</p><p>83a 退回给平台</p><p>S70a 被盗、被抢</p><p>S41a 收派件途中遗失</p><p>Z41d 外包装破损、内件遗失</p><p>Z41e 外包装无损、内件遗失</p><p>Z27a 内件损坏丶外包裝破损</p><p>Z27b 内件损坏丶外包裝无损</p><p></p><p></p>",
    扫描网点名称: "扫描网点名称",
    扫描网点ID: "扫描网点ID",
    业务员姓名: "业务员姓名",
    业务员联系方式: "业务员联系方式",
    扫描网点联系方式: "扫描网点联系方式",
    扫描网点省份: "扫描网点省份",
    扫描网点城市: "扫描网点城市",
    "扫描网点区/县": "扫描网点区/县",
    "上一站(到件)或下一站名称(发件)": "上一站(到件)或下一站名称(发件)",
    "下一站省份（发件扫描类型时提供）": "下一站省份（发件扫描类型时提供）",
    "下一站城市（发件扫描类型时提供）": "下一站城市（发件扫描类型时提供）",
    "下一站区/县（发件扫描类型时提供）": "下一站区/县（发件扫描类型时提供）",
    "经度": "经度",
    "纬度": "纬度",
    "签收人": "签收人",
    "签收类型名称": "签收类型名称<br />1.Consignee（本人签收）<br />2.Collection point/store（自提）<br />3.Others（代收）",
    "电子签名图片": "电子签名图片",
    "签收图片": "签收图片",
    快递轨迹详情: "快递轨迹详情",
    "订阅节点": "订阅节点：1&2&3&4&5&10&11&12&13&16  <p>1、快件揽收</p> <p>2、入仓扫描（停用）</p> <p>3、发件扫描</p> <p>4、到件扫描</p> <p>5、出仓扫描</p> <p>10、快件签收</p> <p>11、问题件扫描</p> <p>12、退回件扫描</p> <p>13、中心到件</p>  <p>16、寄件入库扫描</p>",
    数组: "数组",
    "明文密码:H5CD3zE6": "明文密码:H5CD3zE6",
    'getPrintDesc': '可通过运单号获取电子面单的模板信息。',
    '客户编码': '客户编码',
    'noodleSpecification': '面单规格 1：76*130mm',
    'base64文件流': 'base64文件流',
    printSize: `模版类型:<br/>0: 一联面单<br/>1: 二联面单<br/>2: A4`,
    "base64": "base64解码后得到文件的字节数组",
    OrderDescription_6: "用户通过接口可获取到电子面单的模版信息",
    'weightApi': '接入方在提供了快递重量推送相关信息并完成了接口接入后，当订单相关的重量变化时，系统会根据接入方配置的推送账户主动推送重量、长宽高信息。',
    '长，cm': '长，cm',
    '宽，cm': '宽，cm',
    '高，cm': '高，cm',
    '计费重量': '计费重量',
    'weightSubscribe': '向极兔订阅需推送重量和长宽高的运单号，批量最多支持30个运单号；', // <br/><p style="font-weight: bold">注意事项：需提供回传重量和长宽高的URL</p>
    'dceApplyDesc': '通过极兔完成Dce申报，获取Dce发票密钥',
    'dceItemsDesc': '商品信息列表，至少1件商品',
    'dceSerialNo': '序列号',
    'dceSenderName': '寄件人姓名',
    'dceSenderTaxNumber': '个人税号（11或者14位）',
    'dceSenderPostCode': '寄件邮编（固定8位长度）',
    'dceSenderProv': '寄件州缩写（如SP）',
    'dceSenderCity': '寄件市',
    'dceSenderArea': '寄件区',
    'dceSenderStreet': '寄件街道',
    'dceSenderStreetNumber': '寄件街道号',
    'dceSenderAddress': '寄件详细地址',
    'dceReceiverTaxNumber': '个人税号（11或者14位）',
    'dceReceiverName': '收件人姓名',
    'dceReceiverPostCode': '收件邮编（固定8位长度）',
    'dceReceiverProv': '收件州缩写（如SP）',
    'dceReceiverCity': '收件市',
    'dceReceiverArea': '收件区',
    'dceReceiverStreet': '收件街道',
    'dceReceiverStreetNumber': '收件街道号',
    'dceReceiverAddress': '收件详细地址',
    'dceItemName': '物品名称',
    'dceItemNumber': '件数，≥1',
    'dceItemValue': '物品单价(数值型)，12位整数+2位小数',
    'dceItemNcm': '商品NCM编码',
    'dceId': 'Dce发票密钥',
    'dceRecordTime': '申报成功时间',
    'dceInvoiceMoney': '申报总金额',
    'dceFailReason': '失败原因',
    '经度New': '经度 ·建议至多保留6位小数',
    '纬度New': '纬度 ·建议至多保留6-位小数',
  },
  customsDoc: {
    addOrderDesc: '与J&T签约的客户，可通过此接口创建跨境订单，此类订单为清派一体，不需要再次创建本地订单。',
    updateOrderDesc: '如果包裹重量、箱号等字段在订单下发时无法提供，可以在此接口进行更新',
    addFlightDesc: '航班信息需通过此接口进行更新',
    orderDetailDesc: '通过此接口可获取到清关订单的详细信息',
    cancelOrderDesc: '支持根据提单、包号、订单号维度取消订单',
    printOrderDesc: '用户通过接口可获取到电子面单的模版信息',
    printBoxDesc: '用户通过接口，用自己的大包号查询和打印大包面单',
    updateDirDesc: '用户通过此接口更新尾程订单的Dir信息',
    digestDesc: '签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写',
    billCodeTxlogisticId: '客户订单号与运单号二选一',
    dirAmount: 'Dir金额',
    dirNumber: 'Dir编号',
    dirRegDate: 'Dir注册日期',
    customerOrderId: '客户订单号',
    boxNo: '包裹编号（大包编号）',
    packageWeight: '包裹重量，单位kg',
    waybillOrCustomerOrderId: '运单号(与客户订单号二选一)必填',
    customerOrderOrWaybillId: '客户订单号(与运单号二选一)必填',
    estimatedDarf: '收件人支付的Darf，支持2位小数',
    estimatedGnre: '收件人支付的ICMS/Gnre，支持2位小数',
    departPortCode: '起飞港口',
    arrivePortCode: '目的港口',
    estimatedTransitTime: '航班起飞时间（带时区）',
    estimatedArrivalTime: '航班到达时间（带时区）',
    flightNo: '航班号',
    masterWaybillNo: '提货单号',
    totalPackage: '提单下的所有大包里的全部运单数量，最大值为999',
    totalWeight: '航班总重量，单位kg',
    waybillNos: '运单号（提单下的所有运单号）',
    cancelType: '取消类型，1=提单号取消，2=客户订单号取消，3=大包号取消，不可为空',
    cancelCodes: '取消编码集合，不可为空',
    billCode: '运单编号',
    printType: '1：运单号，2：客户订单号，通过指定类型打印',
    base64Desc: 'base64解码后得到文件的字节数组',
    serviceProvider: 'J&T express',
    timeZone: '巴西时区',
    // 清关下单 2.3.1 字段
    mawbs: '包裹信息',
    customerName: '客户名称',
    waybillId: '运单号',
    anvisaNo: '填运单号',
    serviceType: '服务类型：EC：经济型；ST：标准型；PR：优先型，固定填ST',
    goodsShortDescription: '商品描述',
    freight: '商品运费',
    insurance: '包裹保险费',
    paymentMode: '预付',
    codeEce: '符合PRC发货资质的税号CNPJ',
    nameEce: '符合PRC发货资质的公司名称',
    EstimateCBS: '预估CBS金额',
    EstimatedIBSMunicipality: '预估IBS城市级金额',
    EstimatedIBSState: '预估IBS州级金额',
    receiverAdditionalInfo: '收件人详细地址',
    receiverStreet: '收件人街道',
    receiverAreaId: '收件人地区ID',
    receiverAreaName: '收件人地区名称',
    receiverCityId: '收件人城市ID',
    receiverCityName: '收件人城市',
    receiverProvinceId: '收件人州ID',
    receiverProvinceName: '收件人州',
    receiverCountry: '收件人国家编码',
    receiverCountryIso: '收件人国家<br>中国—CN，巴西-BR',
    receiverPostalCode: '收件人邮编',
    receiverIdNumber: '收件人证件号码',
    receiverIdType: '收件人证件类型：<br>1: CPF<br>2: CNPJ',
    receiverName: '收件人姓名',
    receiverEmail: '收件人邮箱',
    receiverMobilePhone: '收件人电话',
    senderAdditionalInfo: '发件人详细地址',
    senderStreet: '发件人街道',
    senderAreaId: '发件人地区ID',
    senderAreaName: '发件人地区名称',
    senderCityId: '发件人城市ID',
    senderCityName: '发件人城市',
    senderProvinceId: '发件人州ID',
    senderProvinceName: '发件人州',
    senderCountry: '发件人国家ID',
    senderCountryIso: '发件人国家<br>中国—CN，巴西-BR',
    senderPostalCode: '发件人邮编',
    senderIdNumber: '发件人证件号码<br>若为进口包裹，此处应填写00000000000000。',
    senderIdType: '发件人证件类型',
    senderName: '发件人姓名',
    senderEmail: '发件人邮箱',
    senderMobilePhone: '发件人电话',
    omsCustomsGoods: '海关货物信息数组',
    codElementoNcm: 'NCM元素代码',
    comercialValue: '物品价值',
    currency: '货币代码，<br>单位：美元 ,固定传220<br>单位：巴西雷亚尔，固定传790',
    enquadramento: '商品类型代码（填写产品类型，对应以下列表：<br>2：外交邮件，<br>7：非文件或书籍，<br>12：书籍或报纸，<br>16：文件或纸张，<br>21：PRC - 减免 - 少于等于USD50，<br>22：PRC - RTS - 超过USD50），<br>23：当消费者使用 CNPJ 作为税号时，请传 23（无论金额大小）<br><br>注：21、22为PRC包裹，7、12、16 为 RTS（简化税收制度，非 PRC）；<br>当枚举为7、12、16时，字段 CodeECE、NameECE、EstimatedDarf、EstimatedGnre 为 非必填项；',
    goodsDescription: '商品描述',
    goodsWeight: '货物重量，保留2位小数，单位kg',
    height: '高度，单位cm',
    len: '长度，单位cm',
    width: '宽度，单位cm',
    ncmCode: 'NCM代码',
    quantity: '数量',
    sku: 'SKU编号',
    terminalDispatchCode: '三段码',
    orderSourceCode: '订单来源编码',
    orderSourceName: '订单来源名称',
    mawbType: '提单类型',
    comercialDestination: '商业目的地',
    serviceProviderLabel: '服务商名称',
    timeZoneLabel: '时区',
    successLabel: '成功-true，失败-false',
  },
  apiTestDoc: {
    接口说明: "接口说明",
    Headers: "Headers",
    Body: "Body",
    Response: "Response",
    错误代码: "错误代码",
    错误编码: "错误编码",
    错误描述: "错误描述",
    请求头Headers参数: "请求头Headers参数",
    不能为空: "不能为空",
    参数: "参数",
    业务参数签名失败: "业务参数签名失败",
    修改订单失败: "修改订单失败",
    区域不合法: "区域不合法",
    城市不合法: "城市不合法",
    省份不合法: "省份不合法",
    查不到数据: "查不到数据",
    下单失败: "下单失败",
    发件人信息不全: "发件人信息不全",
    "订单重复,无需重复下单！": "订单重复,无需重复下单！",
    收件人信息不全: "收件人信息不全",
    电话号码不能为空: "电话号码不能为空",
    地址信息不全: "地址信息不全",
    "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法": "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法",
    "请检查服务类型是否合法值为 01或 02": "请检查服务类型是否合法值为 01或 02",
    上门服务时间信息不全: "上门服务时间信息不全",
    重量信息不合法: "重量信息不合法",
    物品信息不全: "物品信息不全",
    物品名称不全: "物品名称不全",
    物品类型不全: "物品类型不全",
    "客户订单号已存在,无法下单！": "客户订单号已存在,无法下单！",
    姓名信息非法: "姓名信息非法",
    公司信息过长: "公司信息过长",
    联系信息过长: "联系信息过长",
    邮编或邮箱信息非法: "邮编或邮箱信息非法",
    价格信息非法: "价格信息非法",
    "备注、描述、链接信息非法": "备注、描述、链接信息非法",
    地址信息过长: "地址信息过长",
    街道信息过长: "街道信息过长",
    包裹总件数无效: "包裹总件数无效",
    暂未开通代收货款业务: "暂未开通代收货款业务",
    "支付方式不匹配,PP_CASH,CC_CASH,PP_MM": "支付方式不匹配,PP_CASH,CC_CASH,PP_MM",
    "已取件状态不可修改": "已取件状态不可修改",
    "已取消状态不可修改": "已取消状态不可修改",
    "更新订单失败，请稍后重试！": "更新订单失败，请稍后重试！",
    "始发地信息不全": "始发地信息不全",
    "发票信息不全": "发票信息不全",
    "发票信息不合法": "发票信息不合法",
    "寄件人个人税号信息非法": "寄件人个人税号信息非法",
    "订单数量不同，无法修改订单": "订单数量不同，无法修改订单",
    "请填写正确的快件类型": "请填写正确的快件类型",
    "订单数量不一致": "订单数量不一致",
    "请填写正确的派送类型": "请填写正确的派送类型",
    "请填写正确的寄件/收件酋长国和地区": "请填写正确的寄件/收件酋长国和地区",
    "操作类型不能为空": "操作类型不能为空",
    "COD和COD的币种必须为空或同时必填": "COD和COD的币种必须为空或同时必填",
    "COD(货到付款)不能大于30000": "COD(货到付款)不能大于30000",
    "客户订单号重复，请稍后重试": "客户订单号重复，请稍后重试",
    "请输入正确的税号": "请输入正确的税号",
    "请输入正确的IE号": "请输入正确的IE号",
    "非法发件人邮政编码/非法收件人邮政编码/非法取件人邮政编码": "非法发件人邮政编码/非法收件人邮政编码/非法取件人邮政编码",
    "找不到客户": "找不到客户",
    "客户代码不合法": "客户代码不合法",
    "客户订单号不能为空或太长": "客户订单号不能为空或太长",
    "收货地信息不全": "收货地信息不全",
    "时间范围非法": "时间范围非法",
    "页码非法": "页码非法",
    "超过数据限制": "超过数据限制",
    "客户订单号不能为空或过长": "客户订单号不能为空或过长",
    "取消原因不能为空": "取消原因不能为空",
    运单号非法: "运单号非法",
    运单号个数超过30: "运单号个数超过30",
    运单号个数超过1000: "运单号个数超过1000",
    物品数量非法: "物品数量非法",
    非法金额: "非法金额",
    请输入邮箱: "请输入邮箱",
    邮箱账号: "邮箱账号",
    请输入邮箱验证码: "请输入邮箱验证码",
    邮箱格式不正确: "邮箱格式不正确",
    获取邮箱验证码成功: "获取邮箱验证码成功"
  },
  ...lang,
};

export default messages;
